import { ITagsSchema } from './tags-schema.interface';

export interface IZoneGeometrySchema {
    type: string;
    coordinates: string;
}

export interface IZonePropertiesSchema {
    name: string;
    color: string;
    type: string;
    code: string;
    externalId?: string | null;
    tags?: string[] | ITagsSchema[];
    maxSpeed?: {
        enabled: boolean;
        value: number;
    };
}

export interface IZoneSchema {
    id: string;
    type: string;
    geometry: IZoneGeometrySchema;
    properties: IZonePropertiesSchema;
    createdAt?: string;
    updatedAt?: string;
}
